<template>
  <v-container
    id="about"
    class="pa-0"
    fluid
    tag="section"
  >
    <v-row
      class="ma-0"
      no-gutters
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-img
          height="calc(100vh - 96px - 156px)"
          src="others/pexels-dominika-roseclay-688689.jpg"
          gradient="to top, rgba(235, 207, 199, .3), rgba(224, 175, 156, .0)"
        />
      </v-col>

      <v-col
        class="d-block d-md-flex align-center grey lighten-3 pa-6"
        cols="12"
        md="6"
      >
        <v-card
          color="transparent"
          flat
          class="mx-auto px-3 px-md-12"
          max-width="750"
        >
          <h1
            class="text-center lushary--text mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            404
          </h1>
          <h1
            class="text-center lushary--text mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            Данной страницы не существует
          </h1>

          <div class="lushary--text text-center ">
            Ошибка
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Error',
  }
</script>
